import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SnapmintLoader = () => {
  const location = useLocation();

  useEffect(() => {
    const SNAPMINT_SCRIPT_ID = "snapmint-script";

    const removeSnapmintScript = () => {
      // Remove script with ID
      const existingScript = document.getElementById("snapmint-script");
      if (existingScript) {
        existingScript.remove();
        console.log("Removed script by ID");
      }

      const allScripts = document.querySelectorAll(
        "script[src*='checkout-merchant.snapmint.com']"
      );
      allScripts.forEach((script) => {
        script.remove();
        console.log("Force removed Snapmint script:", script.src);
      });
    };

    const loadSnapmintScript = () => {
      const script = document.createElement("script");
      script.id = SNAPMINT_SCRIPT_ID;
      script.type = "text/javascript";
      script.async = true;
      script.src = "https://checkout-merchant.snapmint.com/js/v1/6236";
      document.body.appendChild(script);
      console.log("Injected new Snapmint script");
    };

    const raf = requestAnimationFrame(() => {
      setTimeout(() => {
        removeSnapmintScript();
        loadSnapmintScript();
      }, 100);
    });

    // On route change unmount
    return () => {
      cancelAnimationFrame(raf);
      removeSnapmintScript();
    };
  }, [location.pathname]);

  return null;
};

export default SnapmintLoader;
